import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
/**
 * * 테이블 내에 쓰이는 버튼 - 캡슐 모양
 */

interface IProps {
  children: string | File;
  onClick?: (e) => void;
  del?: boolean; // del이 들어오면 삭제 버튼인 것 //!23.1.17. backColor로 통일 후 삭제
  disabled?: boolean;
  color?: string;
  name?: string;
  style?: React.CSSProperties;
  backColor?: string;
  hoverColor?: string | null;
}
const CapsuleButton = ({
  children,
  onClick,
  del,
  disabled,
  color,
  name,
  backColor,
  style,
  hoverColor,
}: IProps) => {
  return (
    <Button
      onClick={onClick}
      backColor={backColor}
      del={del}
      disabled={disabled}
      color={color}
      name={name}
      style={style}
      hoverColor={hoverColor}
    >
      {children}
    </Button>
  );
};

export default CapsuleButton;
const Button = styled.button<IProps>`
  color: ${(props) =>
    props.color
      ? props.color
      : props.disabled
      ? props.theme.colors.gray_3
      : theme.colors.black};
  font-weight: ${(props) => (props.color ? '700' : '500')};
  background-color: ${(props) =>
    props.backColor
      ? `${props.backColor}`
      : props.disabled
      ? theme.colors.gray_4
      : theme.colors.table_button};
  border: ${(props) =>
    props.del ? `1px solid ${props.theme.colors.table_button}` : 'none'};
  padding: 0.35rem 1.2rem;
  border-radius: 5rem;
  /* box-shadow: 1px 1px 0px 1px rgb(0 0 0 / 5%); */
  cursor: ${(props) => (props.disabled ? `not-allowed` : `pointer`)};
  img {
    opacity: 0.7;
  }
  &:hover {
    color: ${(props) =>
      props.hoverColor
        ? props.hoverColor
        : props.textColor
        ? props.textColor
        : props.disabled
        ? theme.colors.gray_2
        : '#fff'} !important;
    opacity: ${(props) => (props.hoverColor ? 0.7 : 1)};

    /* box-shadow: ${(props) =>
      props.view ? 'unset' : `1px 1.2px 0px 1.5px rgb(0 0 0 / 15%)`}; */
  }
`;
